export const environment = {
  URL: 'https://back.credienlinea.co',
  USER: 'dev',
  PASS: 'nKDzpKm9n6JZh5g',
  ENTERPRISE: 'Dev',
  SINGLEROUTE: false
};
